const IconButton = ({ onClick, text, Icon, className }) => {
  return (
    <button className={className} onClick={onClick}>
      {Icon ? <Icon className='package-card__btn-icon' /> : ''}
      {text ? <span>{text}</span> : ''}
    </button>
  );
};

export default IconButton;
